<script setup>
import { computed } from 'vue'
import { Badge } from '@/components/ui'

const props = defineProps({
  status: {
    type: String,
    required: true
  }
})

const variant = computed(() => ({
  completed: 'success',
  running: 'warning',
  queued: 'warning',
  waiting: 'warning',
  failed: 'error',
  error: 'error',
  dead_lettered: 'default'
}[props.status] || 'default'))

const label = computed(() => ({
  completed: 'Done',
  running: 'Running',
  queued: 'Queued',
  waiting: 'Waiting',
  failed: 'Failed',
  error: 'Error',
  dead_lettered: 'Dead-Letter'
}[props.status] || props.status))
</script>

<template>
  <Badge :variant="variant">{{ label }}</Badge>
</template>